import { Directive, HostListener, Input } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { InterstitialDialogComponent } from './interstitial-dialog/interstitial-dialog.component';

@Directive({
  selector: '[findersInterstitial]'
})
export class InterstitialDirective {
  @Input('findersInterstitial') externalLink: string;

  constructor(private dialog: MatDialog) {}

  @HostListener('click') onClick() {
    const config = new MatDialogConfig();
    config.data = {
      link: this.externalLink
    };
    this.dialog.open(InterstitialDialogComponent, config);
  }
}
